import React, { useState } from "react";
import { Typography, TextField, Button, CssBaseline, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setCurrentUser } from "redux/features/loginForTestEnv/loginForTestEnvSlice";
import { v4 as uuidv4 } from "uuid";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function SignIn() {
    const classes = useStyles();
    const [formData, setFormData] = useState({
        username: "",
        password: "",
    });

    const dispatch = useDispatch();

    const onChangeInput = (e, inputType) => {
        setFormData({
            ...formData,
            [inputType]: e.target.value,
        });
    };

    const login = (e) => {
        e.preventDefault();

        axios
            .post("/proxy/authProxy/api/auth/login", {
                ...formData,
                forPublic: true,
            })
            .then((response) => {
                dispatch(setCurrentUser(response.data));
                let authorizationAsanUrl;
                if (process.env.REACT_APP_ENV === "test") {
                    authorizationAsanUrl = `${process.env.REACT_APP_DIGITAL_LOGIN_TEST_URL
                        }/grant-permission?client_id=${process.env.REACT_APP_DIGITAL_LOGIN_TEST_CLIENT_ID
                        }&redirect_uri=${process.env.REACT_APP_CABINET_TEST_URL
                        }&response_type=code&state=${uuidv4()}&scope=openid certificate session`;
                } else if (process.env.REACT_APP_ENV === "production") {
                    authorizationAsanUrl = `${process.env.REACT_APP_DIGITAL_LOGIN_URL
                        }/grant-permission?client_id=${process.env.REACT_APP_DIGITAL_LOGIN_CLIENT_ID
                        }&redirect_uri=${process.env.REACT_APP_CABINET_URL
                        }&response_type=code&state=${uuidv4()}&scope=openid certificate session`;
                }

                window.location.href = authorizationAsanUrl;

            })
            .catch((err) => console.log(err));
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                <form className={classes.form} onSubmit={login}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        onChange={(e) => onChangeInput(e, "username")}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        onChange={(e) => onChangeInput(e, "password")}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Sign In
                    </Button>
                </form>
            </div>
        </Container>
    );
}
